
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'LayerSelectorTree'
})
export default class LayerSelectorTree extends Vue {
  @Prop({ default: () => [] })
  value: any[]

  @Prop({ default: () => [] })
  layers: any[]

  selectedLayer: any[] = []

  @Watch('value', { immediate: true })
  onValueChanged () {
    this.selectedLayer = this.value
  }

  @Watch('selectedLayer')
  onSelectedLayerChanged () {
    this.$emit('input', this.selectedLayer)
  }
}
